/**
 * ApexBubble — global FloatButton that opens the Apex drawer.
 *
 * Hidden when:
 *  - On a public route (/signin, /request-access, /agency, /vendor)
 *  - User is not allowlisted
 *  - The drawer is already open (the bubble would visually duplicate the affordance)
 */

import { FloatButton } from "antd";
import { MessageOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";

import { useAuth } from "../../lib/auth";
import { ditColors } from "../../lib/theme";
import { useApex } from "./ApexProvider";
import { isApexHiddenPath } from "./visibility";

export default function ApexBubble() {
  const { allowlisted } = useAuth();
  const location = useLocation();
  const { drawerOpen, openDrawer } = useApex();

  if (!allowlisted) return null;
  if (isApexHiddenPath(location.pathname)) return null;
  if (drawerOpen) return null;

  return (
    <FloatButton
      data-testid="apex-bubble"
      icon={<MessageOutlined aria-hidden />}
      tooltip="Ask Apex"
      onClick={openDrawer}
      aria-label="Open Apex assistant"
      style={{
        right: 24,
        bottom: 24,
        // FloatButton's z-index defaults below modals; bump just enough to clear toasts.
        zIndex: 1100,
        // DIT primary blue background, white icon — passes WCAG AA per global guide.
        backgroundColor: ditColors.primary,
        color: ditColors.white,
      }}
    />
  );
}
